import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from '../Section';
import { CtaButton } from '../CtaButton';
const steps = ['Get immediate access.', 'Open the Playbooks.', 'Review the decision maps.', 'Use the checklists.', 'Work through the cases.'];
export function Guarantee() {
  return <Section tone="light" data-id="element-190" data-mp="29eq8n9oe0nkd">
      <div className="mx-auto max-w-3xl rounded-2xl border-2 border-gold-500/40 bg-white p-6 text-center shadow-xl shadow-navy-950/10 sm:p-9" data-id="element-191" data-mp="29g1a32ud1j8b">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-500/15" data-id="element-192" data-mp="2jbl23e5szxrs">
          <ShieldCheckIcon className="h-9 w-9 text-gold-600" aria-hidden="true" data-id="element-193" data-mp="2oaxro6o27iy2" />
        </span>
        <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.22em] text-gold-600" data-id="element-194" data-mp="2sd2h0t7h5tew">
          7-Day money-back guarantee
        </p>
        <h2 className="mt-2 font-display text-[26px] font-bold leading-tight text-navy-950 sm:text-4xl" data-id="element-195" data-mp="tyzejtmmq2ww">
          Explore the Playbook risk-free
        </h2>

        <ul className="mx-auto mt-6 grid max-w-md gap-2 text-left" data-id="element-196" data-mp="3slol54ewsa80">
          {steps.map((step, index) => <li key={step} className="flex items-center gap-3 rounded-lg bg-slate-50 px-3 py-2.5 text-[15px] text-slate-700" data-id="element-197" data-mp="3ntoq9qdp47ia" data-mpi={index}>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy-900 text-[11px] font-bold text-gold-400" data-id="element-198" data-mp="3dwsijmvmfpes">
                {index + 1}
              </span>
              {step}
            </li>)}
        </ul>

        <p className="mt-6 text-[15px] leading-relaxed text-slate-600" data-id="element-199" data-mp="agldbbxk5k3w">
          See whether Dr. Karito’s system fits the way you approach complex cases. If within 7 days
          you decide the Playbook isn’t right for you, simply request a refund.
        </p>
        <p className="mt-3 font-display text-lg font-bold text-navy-950" data-id="element-200" data-mp="2q77uwqoiw3z6">
          No long-term commitment. No subscription. No risk.
        </p>

        <div className="mt-7 flex justify-center" data-id="element-201" data-mp="2l9zf2wqukc13">
          <CtaButton label="Try it risk-free" subLabel="7 days to decide · Full refund on request" data-id="element-202" data-mp="1d9h68malz9ge" />
        </div>
      </div>
    </Section>;
}